import {
	SET_PRINT_QUEUE_MULTIPLE_ROW_KEY,
	SET_PRINT_QUEUE_MULTIPLE_IFRAME_ACTIVE,
	SET_PRINT_QUEUE_MULTIPLE_LOADED
} from './printing-module-mutation-types';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'printing',
	namespaced: true,
	state: {
		printQueueMultipleIframeActive: false,
		printQueueMultipleLoaded: false,
		printQueueMultipleRowKey: null,
		printQueueMultipleIframeRef: undefined
	},
	mutations: {
		[SET_PRINT_QUEUE_MULTIPLE_ROW_KEY](state, printQueueMultipleRowKey) {
			state.printQueueMultipleRowKey = printQueueMultipleRowKey;
		},
		[SET_PRINT_QUEUE_MULTIPLE_IFRAME_ACTIVE](
			state,
			printQueueMultipleIframeActive
		) {
			state.printQueueMultipleIframeActive = printQueueMultipleIframeActive;
		},
		[SET_PRINT_QUEUE_MULTIPLE_LOADED](
			state,
			{ printQueueMultipleLoaded, printQueueMultipleIframeRef }
		) {
			state.printQueueMultiplLoaded = printQueueMultipleLoaded;
			state.printQueueMultipleIframeRef = printQueueMultipleIframeRef;
		}
	},
	actions: {
		setPrintQueueMultipleRowKeyAction(
			{ commit },
			printQueueMultipleRowKey
		) {
			commit(SET_PRINT_QUEUE_MULTIPLE_ROW_KEY, printQueueMultipleRowKey);
		},
		setPrintQueueMultipleLoadedAction(
			{ commit },
			{ printQueueMultipleLoaded, iframeRef }
		) {
			commit(SET_PRINT_QUEUE_MULTIPLE_LOADED, {
				printQueueMultipleLoaded,
				iframeRef
			});
		},
		setPrintQueueMultipleIframeActiveAction(
			{ commit },
			printQueueMultipleIframeActive
		) {
			commit(
				SET_PRINT_QUEUE_MULTIPLE_IFRAME_ACTIVE,
				printQueueMultipleIframeActive
			);
		}
	},
	getters: {
		printQueueMultipleRowKey: state => state.printQueueMultipleRowKey,
		printQueueMultipleLoaded: state => state.printQueueMultipleLoaded,
		printQueueMultipleIframeActive: state =>
			state.printQueueMultipleIframeActive,
		printQueueMultipleIframeRef: state => state.printQueueMultipleIframeRef
	}
};
